export enum TimeTrackingListTabsEnum {
  OPEN = 'open',
  LOG = 'log',
  DELETED = 'deleted'
}
